<template>
  <div class="rt-upload-video">
    <div
      v-for="(item, index) in videoList"
      ref="item"
      :key="index"
      class="file-item"
    >
      <div class="box">
        <div class="scale">
          <div class="video" @click="videoClick(item.url)">
            <div v-if="!item.url" class="uploading">
              <img src="../../assets/imgs/file_icon.png" alt />
              <div class="uploading-text">
                <span v-if="videoFlag == true && item.videoUploadPercent > 0"
                  >正在上传...</span
                >
                <span v-else-if="item.videoUploadPercent == 100 && !item.name"
                  >上传错误</span
                >
              </div>
            </div>
            <div v-else>
              <video :src="item.url" />
              <div class="layout">
                <rt-icon
                  name="rt-base-angle_right_circle"
                  size="35"
                  color="#fff"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="detail">
          <div class="detail-name">
            <rt-icon name="rt-base-file-video-fill" size="21" color="#55ceb3" />
            <p class="name">{{ item.name }}</p>
          </div>
          <el-progress
            v-if="videoFlag == true && item.videoUploadPercent > 0"
            :percentage="item.videoUploadPercent"
            :show-text="false"
            style="margin-top:7px;"
          />
          <div
            :class="{
              paddingTop: videoFlag == true && item.videoUploadPercent > 0
            }"
            class="progress-operation"
          >
            <p
              v-if="videoFlag == true && item.videoUploadPercent > 0"
              class="progress"
            >
              已上传{{ item.videoUploadPercent }}%
            </p>
            <p
              v-else-if="item.videoUploadPercent == 100 && !item.name"
              class="progress"
            >
              <rt-icon name="rt-base-close_line" size="14" color="#f7734c" />
              <span>上传错误</span>
              <rt-icon name="rt-base-wrong-circle" size="14" color="#a9c2e8" />
            </p>
            <div class="btn">
              <rt-button text type="plain" @click="reUpload(index)"
                >重新上传</rt-button
              >
              <rt-popconfirm
                title="确定需要删除这条内容吗？"
                @onConfirm="onConfirm(item.name, index)"
              >
                <rt-button slot="reference" text type="plain">
                  删除
                </rt-button>
              </rt-popconfirm>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-upload
      ref="upload"
      :show-file-list="false"
      :limit="limit"
      :multiple="multiple"
      :on-success="handleVideoSuccess"
      :before-upload="beforeUploadVideo"
      :http-request="uploadFile"
      :file-list="fileList"
      :style="computedHeight"
      action
      class="avatar-uploader"
    >
      <div class="avator-uploader-main">
        <rt-icon name="rt-base-plus" size="50" class="avatar-uploader-icon" />
        <p class="avatar-uploader-word">请将需要上传的文件添加到此处</p>
      </div>
    </el-upload>
    <el-dialog :visible.sync="videoVisible">
      <video :src="previewUrl" controls="controls" />
    </el-dialog>
  </div>
</template>

<script>
import RtIcon from '../icon/rtIcon';
import RtButton from '../button/rtButton';
import RtPopconfirm from '../popconfirm/rtPopconfirm';

import ossClient from '../upload/aliyun.oss.client';
export default {
  name: 'RtUploadVideo',
  components: {
    RtIcon,
    RtButton,
    RtPopconfirm
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    uploadConf: {
      type: Object,
      required: true,
      default: () => {}
    },
    limit: {
      type: Number,
      default: 10
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      videoFlag: false,
      //是否显示进度条
      videoUploadPercent: '',
      //进度条的进度，
      isShowUploadVideo: false,
      //显示上传按钮
      videoVisible: false,
      previewUrl: '',
      fileList: [],
      videoList: JSON.parse(JSON.stringify(this.value)) || [],
      index: -1,
      computedHeight: {}
    };
  },
  mounted() {
    this.$nextTick(() => {
      let dom = this.$refs.item;
      this.computedHeight = { height: dom[0].offsetHeight };
    });
  },
  methods: {
    //上传前回调
    beforeUploadVideo(file) {
      var fileSize = file.size / 1024 / 1024 < 5000;
      if (
        [
          'video/mp4',
          'video/ogg',
          'video/flv',
          'video/avi',
          'video/wmv',
          'video/rmvb',
          'video/mov'
        ].indexOf(file.type) == -1
      ) {
        this.$message.error('请上传正确的视频格式');
        return false;
      }
      if (!fileSize) {
        this.$message.error('视频大小不能超过5000MB');
        return false;
      }
      this.isShowUploadVideo = false;
    },
    //上传成功回调
    handleVideoSuccess(res) {
      this.isShowUploadVideo = true;
      this.index = -1;
    },
    uploadFile(file) {
      let obj = {
        videoUploadPercent: 0,
        url: '',
        name: ''
      };
      if (this.index >= 0) {
        this.videoList.splice(this.index, 1, obj);
      } else {
        this.videoList.push(obj);
      }
      console.log('file===', file);
      const that = this;
      let fileName = file.file.name;
      ossClient(this.uploadConf)
        // .put(fileName, file.file)
        .multipartUpload(fileName, file.file, {
          progress: function(p) {
            //p进度条的值
            that.videoFlag = true;
            obj.videoUploadPercent = Math.floor(p * 100);
          }
        })
        .then(({ res, url, name }) => {
          if (res && res.status == 200) {
            console.log(`阿里云OSS上传图片成功回调`, res, url, name);
            let response = `http://${this.uploadConf.bucket}.${this.uploadConf.region}.aliyuncs.com/${fileName}`;
            obj.url = response;
            obj.name = name;
            this.handleVideoSuccess(obj);
          }
        })
        .catch(err => {
          console.log(`阿里云OSS上传图片失败回调`, err);
        });
    },
    // 重新上传
    reUpload(index) {
      console.log(333, index);
      this.index = index;
      this.$refs.upload.$refs['upload-inner'].handleClick();
    },
    onConfirm(name, index) {
      this.del(name, index);
    },
    del(name, index) {
      ossClient(this.uploadConf)
        .delete(name)
        .then(res => {
          this.videoList.splice(index, 1);
        })
        .catch(err => {
          console.log('删除失败', err);
        });
    },
    // 视频预览
    videoClick(url) {
      this.videoVisible = true;
      this.previewUrl = url;
    },
    getVideoList() {
      return this.videoList;
    }
  }
};
</script>

<style lang="less" scoped>
@deep: ~'>>>';
.rt-upload-video {
  display: flex;
  flex-wrap: wrap;
  @{deep} {
    .file-item {
      width: 25%;
      margin-bottom: 8px;
      .box {
        width: calc(100% - 8px);
        height: 100%;
        background-color: #f5f7fa;
        .scale {
          width: 100%;
          height: 0;
          padding-bottom: 50%;
          position: relative;
        }
      }
      .video {
        position: absolute;
        cursor: pointer;
        width: 100%;
        height: 100%;
        .uploading {
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          .uploading-text {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            color: #fff;
            font-size: 14px;
            line-height: 19px;
            background-color: rgba(0, 0, 0, 0.5);
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
        video {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        .layout {
          position: absolute;
          top: 0;
          width: 100%;
          height: 100%;
          text-align: center;
          background-color: rgba(0, 0, 0, 0.5);
          opacity: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: opacity 0.3s ease-in;
        }
      }
      .video:hover .layout {
        opacity: 1;
        .rt-icon,
        .rt-icon:active {
          opacity: 0.5;
          &:hover {
            opacity: 1;
          }
        }
      }
      .detail {
        padding: 16px;
        .detail-name {
          display: flex;
          align-items: center;
        }
        p {
          color: #143e81;
        }
        .name {
          font-size: 14px;
          line-height: 19px;
          padding-left: 8px;
        }
        .progress-operation {
          padding-top: 16px;
          display: flex;
          align-items: center;
          &.paddingTop {
            padding-top: 8px;
          }
          .progress {
            font-size: 12px;
            line-height: 16px;
            display: flex;
            align-items: center;
            span {
              padding: 0 4px;
            }
          }
          .btn {
            margin-left: auto;
            .rt-button {
              min-width: unset;
              padding: 0 10px;
              line-height: 19px;
              &:not(:last-child) {
                border-radius: unset;
                border-right: 1px solid #e8ecfc;
              }
              &:last-child {
                padding-right: 0;
              }
            }
          }
        }
      }
    }
    .avatar-uploader {
      width: calc(25% - 8px);
      margin-bottom: 8px;
      .el-upload {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        box-sizing: border-box;
        border: 1px dashed #ccd3ee;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        border: 1px dashed transparent;
        background: linear-gradient(white, white) padding-box,
          repeating-linear-gradient(
            -45deg,
            #ccd3ee 0,
            #ccd3ee 0.3em,
            white 0,
            white 0.4em
          );
      }
      .el-upload:hover {
        border-color: #409eff;
        .avatar-uploader-icon,
        .avatar-uploader-word {
          color: #409eff;
        }
      }
    }
    .avator-uploader-main {
      .avatar-uploader-icon {
        font-size: 50px;
        color: #a9c2e8;
        width: 50px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        margin-bottom: 24px;
      }
      .avatar-uploader-word {
        color: #a9c2e8;
        font-size: 14px;
      }
    }
    .el-icon-document {
      height: unset;
    }
    .el-dialog {
      width: 100%;
      height: 100%;
      margin: 0 !important;
      background: black;
      .el-dialog__header {
        .el-dialog__headerbtn {
          width: 48px;
          height: 48px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.2);
          &:hover {
            .el-icon-close {
              opacity: 1;
            }
          }
          .el-icon-close,
          .el-icon-close:active {
            color: #fff;
            opacity: 0.5;
            &::before {
              font-size: 24px;
              font-family: 'iconfont';
              content: '\e61e';
            }
          }
        }
      }
      .el-dialog__body {
        padding: 0;
        video {
          width: 100%;
          height: 90%;
          margin-top: 2%;
          outline: none;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// rtUploadVideo.vue?f80475a4